import { HotlistFiltersStatus } from '~/lib/applicationEnums'
import { HotlistMatchingSpecFieldId } from '~/store/hotlistMatching'

export default {
  fieldNameShort: {
    [HotlistMatchingSpecFieldId.ColdCalling]: 'Cold-Calling',
    [HotlistMatchingSpecFieldId.Promotion]: 'Promotion',
    [HotlistMatchingSpecFieldId.Closing]: 'Saas B2B Closing',
    [HotlistMatchingSpecFieldId.B2BClosing]: 'Non-Saas B2B Closing',
    [HotlistMatchingSpecFieldId.B2CClosing]: 'Non-Saas B2C Closing',
    [HotlistMatchingSpecFieldId.AccountManagement]: 'Saas B2B Acc. Management',
    [HotlistMatchingSpecFieldId.B2BAccountManagement]: 'Non-Saas B2B Acc. Management',
    [HotlistMatchingSpecFieldId.B2CAccountManagement]: 'Non-Saas B2C Acc. Management',
  },
  section: {
    [HotlistFiltersStatus.Favorites]: 'Favoriten',
    [HotlistFiltersStatus.New]: 'Neue',
    [HotlistFiltersStatus.RequestSent]: 'Anfrage geschickt',
    [HotlistFiltersStatus.RequestAccepted]: 'Anfrage akzeptiert',
    [HotlistFiltersStatus.RequestDeclined]: 'Abgelehnt',
  },
}
